import { IDmSnsMsgSetting, IDmSnsMsgSettingDetail } from '@blcloud/bl-datamodel';
import { DmSnsMsgBodyTypeDiv } from '@blcloud/bl-datamodel/enum/approach/dm-sns-msg-body-type-div';
import { DmSnsMsgBtnActionDiv } from '@blcloud/bl-datamodel/enum/approach/dm-sns-msg-btn-action-div';
import { BlContextMenuItem } from '@blcloud/bl-ng-ui-component';
import { cloneDeep as _cloneDeep } from 'lodash';
import { ContextMenu, DmSnsMsgBodyType, DmSnsMsgSettingEx } from './sns-send-message-content.interface';

/** コンテキストメニューリスト */
export const ContextMenuList: BlContextMenuItem[] = [
  { id: ContextMenu.Add, text: '項目の追加' },
  { id: ContextMenu.Delete, text: '項目の削除' },
  { id: ContextMenu.Up, text: '1つ上に移動' },
  { id: ContextMenu.Down, text: '1つ下に移動' }
];

/** DMSNSメッセージ本文タイプ区分 */
export const DmSnsMsgBodyTypeItems = [
  { code: DmSnsMsgBodyType.Text, name: 'テキスト' },
  { code: DmSnsMsgBodyType.FlexMessage, name: 'カードタイプ' },
  { code: DmSnsMsgBodyType.Image, name: '画像' }
];

/** 絵文字入力項目タイプ */
export enum EmojiInputItemType {
  /** テキスト：本文 */
  NormalText,
  /** カードタイプ：件名 */
  FlexTitle,
  /** カードタイプ：件名2 */
  FlexTitle2,
  /** カードタイプ：件名3 */
  FlexTitle3,
  /** カードタイプ：ラベル */
  FlexLabel,
  /** カードタイプ：ラベル2 */
  FlexLabel2,
  /** カードタイプ：フッター */
  FlexFooter,
  /** カードタイプ：フッター2 */
  FlexFooter2,
  /** カードタイプ：本文 */
  FlexText
}

/** DMSNSメッセージ本文タイプ別バリデーション必須キー定義 */
export const DmSnsMsgBodyTypeRequiredKeys = [
  { code: DmSnsMsgBodyType.Text, keys: ['DmSnsMsgSetting#dmSnsMsgBody'] },
  {
    code: DmSnsMsgBodyType.FlexMessage, keys: [
      'DmSnsMsgSetting#lineMsgTemplateType',
      'DmSnsMsgSetting#dmSnsMsgNotifyDispTitle'
    ]
  },
  { code: DmSnsMsgBodyType.Image, keys: [] }
];

/** デフォルトDMSNSメッセージ設定詳細 */
export const DefaultDmSnsMsgSettingDetail: IDmSnsMsgSettingDetail = {
  /** 項番 */
  itemNumber: 0,
  /** DMSNSメッセージ件名 */
  dmSnsMsgTitle: '',
  /** DMSNSメッセージ件名2 */
  dmSnsMsgTitle2: '',
  /** DMSNSメッセージ件名3 */
  dmSnsMsgTitle3: '',
  /** DMSNSメッセージラベル */
  dmSnsMsgLabel: '',
  /** DMSNSメッセージラベル2 */
  dmSnsMsgLabel2: '',
  /** DMSNSメッセージフッター */
  dmSnsMsgFooter: '',
  /** DMSNSメッセージフッター2 */
  dmSnsMsgFooter2: '',
  /** DMSNSメッセージ本文 */
  dmSnsMsgBody: '',
  /** DMSNSメッセージボタン表示フラグ */
  dmSnsMsgBtnDispFlag: false,
  /** DMSNSメッセージボタン表示名称 */
  dmSnsMsgBtnDispName: '',
  /** DMSNSメッセージボタンアクション区分 */
  dmSnsMsgBtnActionDiv: DmSnsMsgBtnActionDiv.Url,
  /** DMSNSメッセージボタン送信テキスト */
  dmSnsMsgBtnSendText: '',
  /** DMSNSメッセージ遷移先URL */
  dmSnsMsgTransitionUrl: '',
  /** DMSNSメッセージ表示画像 */
  dmSnsMsgDispFile: {},
  /** SNS画像URL */
  snsImageUrl: '',
  /** SNS画像ID */
  snsImageId: null,
  /** DMSNSメッセージ画像アクション有効フラグ */
  dmSnsMsgImageActionValidFlag: false,
  /** DMSNSメッセージ画像アクション区分 */
  dmSnsMsgImageActionDiv: DmSnsMsgBtnActionDiv.Url,
  /** DMSNSメッセージ画像送信テキスト */
  dmSnsMsgImageSendText: '',
  /** DMSNSメッセージ画像遷移先URL */
  dmSnsMsgImageTransitionUrl: '',
};

/** デフォルトDMSNSメッセージ設定 */
export const DefaultDmSnsMsgSetting: IDmSnsMsgSetting = {
  /** 項番 */
  itemNumber: null,
  /** DMSNSメッセージ本文タイプ区分 */
  dmSnsMsgBodyTypeDiv: DmSnsMsgBodyTypeDiv.Text,
  /** LINEメッセージテンプレートタイプ */
  lineMsgTemplateType: null,
  /** DMSNSメッセージ通知表示タイトル */
  dmSnsMsgNotifyDispTitle: '',
  /** DMSNSメッセージ本文 */
  dmSnsMsgBody: '',
  /** DMSNSメッセージ表示画像 */
  dmSnsMsgDispFile: {},
  /** SNS画像URL */
  snsImageUrl: '',
  /** SNS画像ID */
  snsImageId: null,
  /** SNSサムネイル画像URL */
  snsThumbnailImageUrl: '',
  /** SNSサムネイル画像ID */
  snsThumbnailImageId: null,
  /** DMSNSメッセージ設定詳細配列 */
  dmSnsMsgSettingDetailList: [],
};

/** DMSNSメッセージ設定拡張 */
export const DefaultDmSnsMsgSettingEx: DmSnsMsgSettingEx = {
  /** DMSNSメッセージ設定 */
  dmSnsMsgSetting: _cloneDeep(DefaultDmSnsMsgSetting),
  /** ファイル */
  file: null,
  /** 本文文字数カウント */
  count: 0,
  /** 本文スタイルフラグ */
  isStyleDisabled: true,
  /** 表示用LINEメッセージテンプレート名称 */
  dispLineMsgTemplateName: '',
  /** LINEメッセージテンプレート画像URL */
  lineMsgTemplateImageUrl: '',
  /** フレックスメッセージに件名設定可能か */
  isEnabledSetTitleInFlex: false,
  /** フレックスメッセージに件名2設定可能か */
  isEnabledSetTitle2InFlex: false,
  /** フレックスメッセージに件名3設定可能か */
  isEnabledSetTitle3InFlex: false,
  /** フレックスメッセージにラベル設定可能か */
  isEnabledSetLabelInFlex: false,
  /** フレックスメッセージにラベル2設定可能か */
  isEnabledSetLabel2InFlex: false,
  /** フレックスメッセージに本文設定可能か */
  isEnabledSetBodyInFlex: false,
  /** フレックスメッセージにフッター設定可能か */
  isEnabledSetFooterInFlex: false,
  /** フレックスメッセージにフッター2設定可能か */
  isEnabledSetFooter2InFlex: false,
  /** フレックスメッセージに画像設定可能か */
  isEnabledSetImageInFlex: false,
  /** テキストメッセージ本文入力エリア最終選択開始位置 */
  normalTextInputViewLastSelectionStart: 0,
  /** テキストメッセージ本文入力エリア最終選択終了位置 */
  normalTextInputViewLastSelectionEnd: 0,
  /** フレックスメッセージ件名入力エリア最終選択開始位置 */
  flexTitleInputViewLastSelectionStart: 0,
  /** フレックスメッセージ件名入力エリア最終選択終了位置 */
  flexTitleInputViewLastSelectionEnd: 0,
  /** フレックスメッセージ件名2入力エリア最終選択開始位置 */
  flexTitle2InputViewLastSelectionStart: 0,
  /** フレックスメッセージ件名2入力エリア最終選択終了位置 */
  flexTitle2InputViewLastSelectionEnd: 0,
  /** フレックスメッセージ件名3入力エリア最終選択開始位置 */
  flexTitle3InputViewLastSelectionStart: 0,
  /** フレックスメッセージ件名3入力エリア最終選択終了位置 */
  flexTitle3InputViewLastSelectionEnd: 0,
  /** フレックスメッセージラベル入力エリア最終選択開始位置 */
  flexLabelInputViewLastSelectionStart: 0,
  /** フレックスメッセージラベル入力エリア最終選択終了位置 */
  flexLabelInputViewLastSelectionEnd: 0,
  /** フレックスメッセージラベル2入力エリア最終選択開始位置 */
  flexLabel2InputViewLastSelectionStart: 0,
  /** フレックスメッセージラベル2入力エリア最終選択終了位置 */
  flexLabel2InputViewLastSelectionEnd: 0,
  /** フレックスメッセージフッター入力エリア最終選択開始位置 */
  flexFooterInputViewLastSelectionStart: 0,
  /** フレックスメッセージフッター入力エリア最終選択終了位置 */
  flexFooterInputViewLastSelectionEnd: 0,
  /** フレックスメッセージフッター2入力エリア最終選択開始位置 */
  flexFooter2InputViewLastSelectionStart: 0,
  /** フレックスメッセージフッター2入力エリア最終選択終了位置 */
  flexFooter2InputViewLastSelectionEnd: 0,
  /** フレックスメッセージ本文入力エリア最終選択開始位置 */
  flexTextInputViewLastSelectionStart: 0,
  /** フレックスメッセージ本文入力エリア最終選択終了位置 */
  flexTextInputViewLastSelectionEnd: 0
};



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-modal/content/sns-send-message-content.const.ts